import { emptyV2Api as api } from "../emptyV2Api";
import { DeprecatedSku } from "./DeprecatedSku";
import { InventoryItem } from "./InventoryItem";
import { InventoryItemOverview } from "./InventoryItemOverview";
import { InventoryUploadJob } from "./InventoryUploadJob";

const SLUG = "/inventory"

const injectedApi = api
  .enhanceEndpoints({ addTagTypes: ["inventory", "deprecatedVSku"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getInventory: build.query<InventoryItem[], void>({
        query: () => SLUG + "/manage",
        providesTags: ["inventory"]
      }),
      getInventoryItemByIccid: build.query<InventoryItem, string>({
        query: (iccid) => SLUG + "/manage?iccid=" + iccid,
        providesTags: ["inventory"]
      }),

      getInventoryUploadJobs: build.query<InventoryUploadJob[], void>({
        query: () => SLUG + "/upload",
        providesTags: ["inventory"]
      }),
      getInventoryOverview: build.query<InventoryItemOverview[], void>({
        query: () => SLUG + "/overview",
        providesTags: ["inventory"]
      }),
      getInventoryOverviewWithDeprecated: build.query<InventoryItemOverview[], void>({
        query: () => SLUG + "/overview?includeDeprecated=true",
      }),
      putInventoryItem: build.mutation<InventoryItem, InventoryItem>({
        query: (item) => ({
          url: SLUG + "/manage",
          method: "PUT",
          body: item
        }),
        invalidatesTags: ["inventory"]
      }),

      getDeprecatedVSkus: build.query<DeprecatedSku[], void>({
        query: () => SLUG + "/deprecate",
        providesTags: ["deprecatedVSku"]
      }),
      postDeprecatedVSku: build.mutation<void, string>({
        query: (vsku) => ({
          url: SLUG + "/deprecate",
          method: "POST",
          body: { vsku }
        }),
        invalidatesTags: ["deprecatedVSku"]
      }),
      deleteDeprecatedVSku: build.mutation<void, string>({
        query: (vsku) => ({
          url: SLUG + "/deprecate?vsku=" + vsku,
          method: "DELETE",
          // body: { vsku }
        }),
        invalidatesTags: ["deprecatedVSku"]
      }),
    })
});

export const {
  useGetInventoryQuery,
  useGetInventoryItemByIccidQuery,
  useGetInventoryUploadJobsQuery,
  useGetInventoryOverviewQuery,
  useGetInventoryOverviewWithDeprecatedQuery,
  usePutInventoryItemMutation,

  useGetDeprecatedVSkusQuery,
  usePostDeprecatedVSkuMutation,
  useDeleteDeprecatedVSkuMutation,
} = injectedApi;